import * as apiFactory from "./ApiFactory";

import type { ScratchpadDocument } from "@recordsure/unity-scratchpad/document";
import type { ScratchpadEntry, ScratchpadPersistence } from "@recordsure/unity-scratchpad/machine";

export interface ScratchpadLocation {
  client: string;
  brand: string;
  casename: string;
}

// The owner's scratchpad, or another author's by `reference`. Rejects with a 404 when it doesn't exist.
export async function get(location: ScratchpadLocation, reference?: string): Promise<ScratchpadEntry> {
  const client = await apiFactory.WithBearer();
  return await client.getWithObject<{ scratchPadReference?: string }, ScratchpadEntry>(
    `api/ScratchPad/${location.client}/${location.brand}/${encodeURIComponent(location.casename)}`,
    reference == null ? {} : { scratchPadReference: reference },
  );
}

export async function getSiblings(
  location: ScratchpadLocation,
): ReturnType<ScratchpadPersistence<ScratchpadLocation>["getSiblings"]> {
  const client = await apiFactory.WithBearer();
  return await client.get(
    `api/ScratchPad/siblings/${location.client}/${location.brand}/${encodeURIComponent(location.casename)}`,
  );
}

export async function save(
  location: ScratchpadLocation,
  value: ScratchpadDocument,
  concurrency: string | null,
): ReturnType<ScratchpadPersistence<ScratchpadLocation>["save"]> {
  const client = await apiFactory.WithBearer();
  return await client.post(
    `api/ScratchPad/${location.client}/${location.brand}/${encodeURIComponent(location.casename)}`,
    { value, concurrency },
  );
}

export async function remove(location: ScratchpadLocation, concurrency: string): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.delete<{ concurrency: string }, void>(
    `api/ScratchPad/${location.client}/${location.brand}/${encodeURIComponent(location.casename)}`,
    { concurrency },
  );
}
